import { AbTestTypeCategory, AbTestWidgetType } from './models/AbTestCreationType';
import { AbTestGroupMode } from '@pdqdev/pdq-shared/dist/entities/AbTestGroupMode';

export const getIsThemeTest = (testType: AbTestTypeCategory | undefined): boolean =>
  testType === AbTestTypeCategory.CROSS_SITE ||
  testType === AbTestTypeCategory.PRODUCT_PAGE ||
  testType === AbTestTypeCategory.SMART_CART;

export const getIsThemeWidget = (widgetType: string): boolean =>
  widgetType === AbTestWidgetType.CROSS_SITE ||
  widgetType === AbTestWidgetType.PRODUCT_PAGE ||
  widgetType === AbTestWidgetType.SMART_CART;

export const getIsCheckoutProfileTest = (testType: AbTestTypeCategory | undefined): boolean =>
  testType === AbTestTypeCategory.CHECKOUT_PROFILE;

/** Tests whose winner is applied outside PDQ (in Shopify) rather than by switching a shipping rates group */
export const getIsWinnerAppliedInShopify = (testType: AbTestTypeCategory | undefined): boolean =>
  getIsThemeTest(testType) || getIsCheckoutProfileTest(testType);

export const getWinnerButtonText = (testType: AbTestTypeCategory, verbOnly = false): string => {
  const verb = getIsWinnerAppliedInShopify(testType) ? 'Mark' : 'Set';
  return verbOnly ? verb : `${verb} as winner`;
};

export const shouldUseAbTestModalV2 = (
  shopMetadata: { enableAbtestMultiControlGroups?: boolean } | undefined,
  testType: AbTestTypeCategory | undefined,
  testMode?: AbTestGroupMode,
): boolean => {
  const baseCondition = shopMetadata?.enableAbtestMultiControlGroups && testType === AbTestTypeCategory.SHIPPING_RATES;

  if (testMode) {
    return baseCondition && testMode === AbTestGroupMode.MULTIPLE_CONTROL_GROUPS;
  }

  return baseCondition;
};
